import React from "react";

import Shudder from "../images/shudderlogo.png";
import IMDBLogo from "../images/imdblogo.png";
import MetacriticIcon from "../images/metacriticlogo.png";
import { Movie } from "../../fetcher/src/types";
import styled from "@emotion/styled";
import { Eye } from "./Eye";
import { Star } from "./Star";

export const MovieView = ({
  movie,
  favorited,
  seen,
  handleSeen,
  handleFavorited,
}: { movie: Movie } & {
  favorited: boolean;
  seen: boolean;
  handleSeen: (movie: Movie) => void;
  handleFavorited: (movie: Movie) => void;
}) => {
  return (
    <MovieBox key={movie.title + movie.release.date}>
      <SubTitle>
        <Data>
          <TitleBar>
            <h4>
              <TitleLink target="_blank" href={movie.url}>
                {movie.title} ({movie.release.date.slice(0, 4)})
              </TitleLink>
            </h4>
            <CommandButtons>
              <SeenButton
                aria-label={seen ? "seen" : "not seen"}
                onClick={() => handleSeen(movie)}
              >
                {seen ? <Eye color={"#FFF"} /> : <Eye color={"#888"} />}
              </SeenButton>

              <SeenButton
                aria-label={favorited ? "favorited" : "not favorited"}
                onClick={() => {
                  handleFavorited(movie);
                }}
              >
                {favorited ? <Star color={"#FFF"} /> : <Star color={"#888"} />}
              </SeenButton>
            </CommandButtons>
          </TitleBar>
          <ScrollContainer>
            <div>{movie.language}</div>

            <div>{movie.genres.join(", ")}</div>
            <div>{movie.director}</div>

            <div>
              <Ratings>
                <Rating>
                  <RatingIcon src={Shudder} title="shudder" />{" "}
                  {movie.userRating.rating.toPrecision(2) + "/5"}
                </Rating>
                <Rating>
                  {movie.imdbAPIRating.imdbRating && (
                    <>
                      <RatingIcon src={IMDBLogo} title="imdb" />{" "}
                      {movie.imdbAPIRating.imdbRating}/10
                    </>
                  )}
                </Rating>
                <Rating>
                  {movie.imdbAPIRating.metascore && (
                    <>
                      <RatingIcon src={MetacriticIcon} />
                      {movie.imdbAPIRating.metascore}/100
                    </>
                  )}
                </Rating>
              </Ratings>
              <Description>{movie.description}</Description>
            </div>
          </ScrollContainer>
        </Data>
        <PosterImage src={movie.imageUrl} />
      </SubTitle>
    </MovieBox>
  );
};

const Rating = styled.div();
const Ratings = styled.div({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid white",
});
const ScrollContainer = styled.div({
  "::-webkit-scrollbar": {
    width: "0pb" /* Remove scrollbar space */,
    background: "transparent" /* Optional: just make scrollbar invisible */,
  },
  /* Optional: show position indicator in red */
  "::-webkit-scrollbar-thumb": {
    background: "#666666",
    borderRadius: "30px",
  },
  overflowY: "scroll",
  height: "20vh",
});
const SubTitle = styled.div({ display: "flex" });
const Data = styled.div();
const PosterImage = styled.img({ height: "30vh" });
const Description = styled.div({});
const TitleLink = styled.a({
  color: "white",
  height: "10vh",
  textDecoration: "none",
  ":visited": { color: "grey" },
  ":hover": { textDecoration: "underline" },
});

const RatingIcon = styled.img({ height: "15px" });

const MovieBox = styled.div(() => ({
  marginTop: "3vw",
  backgroundColor: "black",
  overflow: "hidden",
  minWidth: "280px",
  display: "inline-block",
  maxWidth: "500px",
  height: "30vh",
}));

const TitleBar = styled.div({
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid white",
});

const SeenButton = styled.button({
  border: "none",
  background: "none",
  color: "white",
  display: "flex",
  alignItems: "center",
  height: "25px",
  padding: "0px",
});

const CommandButtons = styled.div({ display: "flex", flexDirection: "row" });
